import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useScrollToTop } from 'hooks/useScrollToTop/useScrollToTop';
import { ContentContainer, PageContainer } from './CentralIslandLayout.styled';

export type CentralIslandLayoutProps = {
    children: React.ReactNode;
    fillSpaceWithIsland?: boolean;
    stickToTop?: boolean;
};

export const CentralIslandLayout = ({
    children,
    fillSpaceWithIsland = false,
    stickToTop = false,
}: CentralIslandLayoutProps) => {
    const pageContainerRef = useRef<HTMLDivElement>(null);
    useScrollToTop({ elementRef: pageContainerRef });

    return (
        <PageContainer ref={pageContainerRef} stickToTop={stickToTop}>
            <ContentContainer fillSpaceWithIsland={fillSpaceWithIsland}>
                {children}
            </ContentContainer>
        </PageContainer>
    );
};

export type CentralIslandLayoutWithOutletProps = Pick<
    CentralIslandLayoutProps,
    'fillSpaceWithIsland' | 'stickToTop'
>;

export const CentralIslandLayoutWithOutlet = ({
    fillSpaceWithIsland,
    stickToTop,
}: CentralIslandLayoutWithOutletProps) => (
    <CentralIslandLayout fillSpaceWithIsland={fillSpaceWithIsland} stickToTop={stickToTop}>
        <Outlet />
    </CentralIslandLayout>
);
